import { render, staticRenderFns } from "./SiloList.vue?vue&type=template&id=1a9bd69c"
import script from "./SiloList.vue?vue&type=script&lang=js"
export * from "./SiloList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports